import { isApolloError } from "apollo-client/errors/ApolloError";

export function formatError(error) {
  let message = error.message || "Internal Error";

  if (isApolloError(error)) {
    message = error.graphQLErrors.map(v => `${v.message}`).join("\n");
  }

  return message;
}

export function onError(error, toast, isInfo = false) {
  console.log(error.graphQLErrors);

  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    error.graphQLErrors.forEach(({ message }) => {
      isInfo ? toast.info(message) : toast.error(message);
    });
  } else {
    isInfo ? toast.info(error.message) : toast.error(error.message);
  }
}
